import React from 'react'
import { useNavigate } from 'react-router-dom'

import '../styles/OnBoarding.css'

import consumer from '../../../assets/img/fruitLogo.png';

function OnBoarding() {
  const navigate = useNavigate()

  const handleNext = () => {
    navigate('/consumer/onboarding/step2')
  }

  const handleBack = () => {
    navigate('/home/dashboard')
  }
  return (
    <>
      <h5>OnBoarding - Consumer</h5>
      <div className='onboardingBox'>
        <div className="buttonsOnboarding">
          <div>
            <a href="fullSign"><img src={consumer} alt="consumer" /></a>
          </div>
          <div>
            <a href="fullSign"><img src={consumer} alt="consumer" /></a>
          </div>
        </div>
      </div>
    </>
  )
}

export default OnBoarding